module.exports = __webpack_public_path__ + "static/media/12.21ec0369.png";